import { Button, CommentIcon, IconButton } from '@farol-ds/react'
import { GA4EventProps, useMetrics } from '@jusbrasil-web/docview/core'
import { useGA4Dispatcher } from '@jusbrasil-web/shared-ga4'
import { GA4ClickEvent, SELECTED_OPTION } from '@jusbrasil-web/shared-ga4-events'

import styles from './comment-button.module.scss'

export type CommentButtonProps = {
  ga4EventData?: GA4EventProps
}

export function CommentButton(props: CommentButtonProps) {
  const { ga4EventData } = props

  const { ref: dispatcherRef, sendMetrics } = useMetrics<HTMLDivElement>()
  const { sendGA4Event } = useGA4Dispatcher()

  const handleClick = () => {
    sendMetrics('Doc.CommentsAnchorClicked')
    sendGA4Event(
      new GA4ClickEvent({
        ...ga4EventData,
        componentName: null,
        selectedOption: SELECTED_OPTION.COMMENT_DOCUMENT,
      })
    )
  }

  return (
    <div ref={dispatcherRef}>
      <IconButton
        className={styles.iconBtn}
        label="Comentar"
        kind="tertiary"
        onClick={handleClick}
        data-testid="comment-button-icon"
        asChild
      >
        <a href="#comments">
          <CommentIcon />
        </a>
      </IconButton>
      <Button
        className={styles.btn}
        leftIcon={<CommentIcon />}
        onClick={handleClick}
        data-testid="comment-button"
        asChild
      >
        <a href="#comments">Comentar</a>
      </Button>
    </div>
  )
}
